import React from 'react';
import { Route, Switch } from 'react-router-dom';
import RequestPassword from './RequestPassword';
import ResetPassword from './ResetPassword';
function Auth(props) {
    const {
        match: { path },
    } = props;

    return (
        <Switch>
            <Route
                path={path + '/request-password'}
                component={RequestPassword}
            />
            <Route path={path + '/reset-password'} component={ResetPassword} />
        </Switch>
    );
}

export default Auth;
